module.exports = __webpack_public_path__ + "static/img/fw_pic2.4655079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/fw_pic2.jpg
// module id = nzWz
// module chunks = 37